import { useEffect } from 'react';
import './App.css';
import { BrowserRouter, Routes, Route, useLocation, Navigate } from 'react-router-dom';
import { Toaster } from './components/ui/sonner';
import TopBar from './components/TopBar';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import Home from './pages/Home';
import About from './pages/About';
import Transform from './pages/Transform';
import Contact from './pages/Contact';
import LocationPage from './pages/LocationPage';
import AdminDashboard from './pages/AdminDashboard';
import ServicePage from './pages/ServicePage';
import TimetablePage from './pages/TimetablePage';

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => { window.scrollTo({ top: 0, behavior: 'instant' }); }, [pathname]);
  return null;
}

function RevealObserver() {
  useEffect(() => {
    const els = document.querySelectorAll('.reveal');
    const io = new IntersectionObserver((entries) => {
      entries.forEach((e) => { if (e.isIntersecting) e.target.classList.add('in'); });
    }, { threshold: 0.12 });
    els.forEach((el) => io.observe(el));
    return () => io.disconnect();
  });
  return null;
}

function App() {
  return (
    <div className="App bg-background text-foreground">
      <BrowserRouter>
        <ScrollToTop />
        <RevealObserver />
        <TopBar />
        <Navbar />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<About />} />
          <Route path="/transform" element={<Transform />} />
          <Route path="/results" element={<Navigate to="/transform" replace />} />
          <Route path="/timetable" element={<TimetablePage />} />
          <Route path="/service/:slug" element={<ServicePage />} />
          <Route path="/location" element={<LocationPage />} />
          <Route path="/faq" element={<Navigate to="/contact" replace />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/admin" element={<AdminDashboard />} />
        </Routes>
        <Footer />
        <Toaster position="top-right" richColors />
      </BrowserRouter>
    </div>
  );
}

export default App;
